import { AppConfigContext } from '@config/AppConfig';
import { IMasterScheduleDetail } from '@masterSchedule/detail/masterScheduleDetail.models';
import { useNominatedInMasterSchedule } from '@masterSchedule/masterSchedule.hooks';
import { ERolePermission, ESiteTransmittalPermission } from '@userProfile/permission/permission.constants';
import { isPermittedAsSiteOperationUser } from '@userProfile/permission/permission.services';
import { useContext } from 'react';

export const useAllowNewST = () => {
  const appConfigs = useContext(AppConfigContext);
  return isPermittedAsSiteOperationUser(appConfigs.configs.myPermissions, [
    ERolePermission.TEMPORARY_WORK_COORDINATOR,
    ERolePermission.TEMPORARY_WORK_COORDINATOR_FOR_MINOR_WORKS,
    ERolePermission.PROJECT_MANAGER,
    ERolePermission.SITE_ENGINEER,
    ERolePermission.OPERATIONS_SECRETARY,
  ]);
};
export const useAllowNewSTWithT1 = (masterScheduleIsCancelled: boolean, masterScheduleType: string) => {
  const isPermitted = useAllowNewST();
  // TODO check master schedule type
  if (masterScheduleIsCancelled || masterScheduleType === 'D') return false;
  return isPermitted;
};

export const useAllowEndorseST = (masterSchedule?: IMasterScheduleDetail) => {
  const appConfigs = useContext(AppConfigContext);
  const { isTwc } = useNominatedInMasterSchedule(masterSchedule);
  if (!isTwc) return false;
  return isPermittedAsSiteOperationUser(appConfigs.configs.myPermissions, [ESiteTransmittalPermission.ENDORSE]);
};
